import React from 'react';
import { translations } from '../data/translations';

const Settings = ({ settings, setSettings, language, onNavigateHome }) => {
  const updateSetting = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  return (
    <div className="settings-container">
      {onNavigateHome && (
        <button
          type="button"
          className="icon-button page-home-button"
          onClick={onNavigateHome}
          aria-label={translations[language].homeNavLabel}
          title={translations[language].homeNavLabel}
        >
          &#8962;
        </button>
      )}

      <h2>{translations[language].settingsTitle}</h2>

      <div className="setting-group">
        <h3>{translations[language].timingSettings}</h3>

        <label>
          {translations[language].contractionTime}
          <select
            className="select-setting"
            value={settings.contractionTime}
            onChange={(e) => updateSetting('contractionTime', parseInt(e.target.value, 10))}
          >
            <option value={3}>3</option>
            <option value={4}>4</option>
            <option value={5}>5</option>
          </select>
        </label>

        <label>
          {translations[language].relaxationTime}
          <select
            className="select-setting"
            value={settings.relaxationTime}
            onChange={(e) => updateSetting('relaxationTime', parseInt(e.target.value, 10))}
          >
            <option value={3}>3</option>
            <option value={4}>4</option>
            <option value={5}>5</option>
          </select>
        </label>
      </div>

      <div className="setting-group">
        <h3>{translations[language].iterationSettings}</h3>

        <label>
          {translations[language].iterations}
          <select
            className="select-setting"
            value={settings.iterations}
            onChange={(e) => updateSetting('iterations', parseInt(e.target.value, 10))}
          >
            {[10, 11, 12, 13, 14, 15].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="setting-group">
        <h3>{translations[language].colorSettings}</h3>

        <label className="color-field" htmlFor="contractionColor">
          <span className="color-field__control">
            <input
              id="contractionColor"
              type="color"
              className="color-field__input"
              value={settings.contractionColor}
              onChange={(e) => updateSetting('contractionColor', e.target.value)}
            />
            <span aria-hidden="true" className="color-field__pipette" />
          </span>
          <span className="color-field__label-text">
            {translations[language].contractionColor}
          </span>
        </label>

        <label className="color-field" htmlFor="relaxationColor">
          <span className="color-field__control">
            <input
              id="relaxationColor"
              type="color"
              className="color-field__input"
              value={settings.relaxationColor}
              onChange={(e) => updateSetting('relaxationColor', e.target.value)}
            />
            <span aria-hidden="true" className="color-field__pipette" />
          </span>
          <span className="color-field__label-text">
            {translations[language].relaxationColor}
          </span>
        </label>
      </div>
    </div>
  );
};

export default Settings;
